/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import Base from './Base';
import { Route } from 'react-router-dom';
import { IconSettings } from '@salesforce/design-system-react';

// Root of Application
const Root = () => {
  return (
    <IconSettings iconPath="/assets/icons">
      <Route path='/' component={Base} />
    </IconSettings>
  );
};

export default Root;